import { Appearance, useAppearance } from '@/hooks/use-appearance';
import { cn } from '@/lib/utils';
import { LucideIcon, Monitor, Moon, Sun } from 'lucide-react';
import { HTMLAttributes } from 'react';

export default function AppearanceSwitcher({ className = '', ...props }: HTMLAttributes<HTMLDivElement>) {
    const { appearance, updateAppearance } = useAppearance();

    const themes: { value: Appearance; icon: LucideIcon; label: string }[] = [
        { value: 'light', icon: Sun, label: 'Light' },
        { value: 'dark', icon: Moon, label: 'Dark' },
        { value: 'system', icon: Monitor, label: 'System' },
    ];

    return (
        <div className={cn('bg-muted flex gap-0.5 rounded-md p-0.5', className)} {...props}>
            {themes.map(({ value, icon: Icon, label }) => (
                <button
                    key={value}
                    onClick={() => updateAppearance(value)}
                    className={cn(
                        'flex flex-1 items-center justify-center rounded-sm p-1.5 transition-colors',
                        appearance === value ? 'bg-card shadow-sm' : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground',
                    )}
                    title={label}
                >
                    <Icon className="h-4 w-4" />
                </button>
            ))}
        </div>
    );
}
